import React from 'react';
import { useEndConversation } from '../hooks/endConversation';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faCircleUp, faPhoneSlash } from '@fortawesome/free-solid-svg-icons'


const Upgrade = () => {

  const { endConversation } = useEndConversation();

  const handleUpgradeClick = () => {
    endConversation();
    if (window.self !== window.top) { // checking if it is an iframe
      window.parent.location.href = 'https://madameas.com/pricing';
    } else {
      window.location.href = 'https://madameas.com/pricing';
    }
  };

  const moreActivitiesClick = () => {
    endConversation();

    if (window.self !== window.top) { // checking if it is an iframe
      window.parent.location.href = 'https://madameas.com/dashboard';
    } else {
      window.location.href = 'https://madameas.com/dashboard';
    }
  }
  // TODO - Make Madame AI talk about the limit and plan(s)

  return (
    <div className='upgrade'>
      <h1>Bon travail! <FontAwesomeIcon icon={faStar} /></h1>
      <p>Great job today! You have reached your limit for the day.<br />Keep practicing your French every day, even for a few minutes!</p>

      <div className="button end-conversation" onClick={moreActivitiesClick}><FontAwesomeIcon icon={faPhoneSlash} /> End conversation</div>

      <div className="button upgrade-button" onClick={handleUpgradeClick}>
        <FontAwesomeIcon icon={faCircleUp} /> Get more time with MadameAI
      </div>
      <div className="button more-button" onClick={moreActivitiesClick}>
        More activities
      </div>

    </div>
    
  );
};

export default Upgrade;
